import { render, staticRenderFns } from "./Taslimat.vue?vue&type=template&id=3b2a4cb1"
import script from "./Taslimat.vue?vue&type=script&lang=js"
export * from "./Taslimat.vue?vue&type=script&lang=js"
import style0 from "./Taslimat.vue?vue&type=style&index=0&id=3b2a4cb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports